import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    }
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0px 1px 0px #E5E5E5',
    boxSizing: 'border-box',
    marginBottom: '5px',
    minHeight: '48px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
       minHeight: 'auto'
    }
  },
  toolbarLeft: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '140px',
    height: '100%',
    borderRight: '1px solid #E2EBF6',
    boxSizing: 'border-box',
    color: '#59758B',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      borderRight: 'none',
      borderBottom: '1px solid #E2EBF6',
      justifyContent: 'center'
    }
  },
  toolbarRight: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: '30px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingRight: '10px',
      justifyContent: 'flex-start'
    }
  },
  toolbarTitle: {
    padding: '12px 30px 12px 30px',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '24px',
    color: '#000000',
    [theme.breakpoints.down('sm')]: {
      padding: '12px 10px',
      fontSize: '16px',
    }
  },
  tabsRoot: {
    width: '470px',
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  tabs: {
    flex: '0 1 220px',
    [theme.breakpoints.down('sm')]: {
      flex: '0 1 auto'
    }
  },
  customTabRoot: {
    padding: '0',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 15px',
      fontSize: '12px',
      overflowX: 'auto',  
      display: 'flex', 

    }
  },
  datePickerWrapper: {
    width: '255px',
    maxHeight: '48px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  customTabWrapper: {
    alignItems: 'center',
    fontSize: '13px'
  },
  toolbarSwitchers: {
    flexDirection: 'row',
    minWidth: '540px',
    alignItems: 'center',
    borderRight: '1px solid #E2EBF6',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      borderRight: 'none',
      borderBottom: '1px solid #E2EBF6',
       justifyContent: 'space-between'
    }
  },
  textColorInheritCustom: {
    opacity: 1,
    color: '#335267'
  },
  inputClassName: {
    border: 'none !important',

  },
  selected: {
    backgroundColor: '#E2F5F8',
    color: '#071B27 !important',
    fontWeight: 'bold'
  },
  customTabWrapper: {
    padding: '0'
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    // justifyContent: 'space-between',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%'
    }
  }
}));

export default useStyles;
